var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypography = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M4.46 2.892a.57.57 0 0 0-.568.567v.757a.946.946 0 0 1-1.892 0V3.46A2.46 2.46 0 0 1 4.46 1h7.567a2.46 2.46 0 0 1 2.46 2.46v.756a.946.946 0 1 1-1.892 0V3.46a.57.57 0 0 0-.568-.567h-2.46a.38.38 0 0 0-.378.378v9.46c0 .209.17.378.379.378h.946a.946.946 0 0 1 0 1.892H5.973a.946.946 0 1 1 0-1.892h.946c.209 0 .378-.17.378-.378V3.27a.38.38 0 0 0-.378-.378z",
  clipRule: "evenodd"
})));
export default SvgTypography;